import React, {useCallback, useEffect, useState} from 'react';
import SamplesListTableComponent from "./samples-list-table/samplesListTableComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {ISample} from "../../shared/models/sample.model";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import CommonService from "../../shared/services/common.service";
import {IAPIResponseType} from "../../shared/models/api.model";
import SelectDropdownComponent from "../../shared/components/core/select-dropdown/SelectDropdownComponent";
import {ITableColumn} from "../../shared/models/table.model";
import {Download, RemoveCircle} from "@mui/icons-material";
import TableComponent from "../../shared/components/table-components/table/tableComponent";
import TooltipComponent from "../../shared/components/tooltip/tooltipComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SamplesFiltersComponent from "./samples-filters/SamplesFiltersComponent";
import commonService from "../../shared/services/common.service";
import {APIConfig} from "../../constants";
import {LabRoleType} from "../../shared/models/lab.model";
import useFetch from "../../shared/hooks/useFetch";

interface SamplesListScreenProps {

}

const FiltersInitialState: any = {
    search: '',
    facilityObjs: [],
    facilityIds: [],
    locationObjs: [],
    locationIds: [],
    sampleTypes: [],
    sampleTypesObjs: [],
    testCodeObjs: [],
    testIds: [],
    statuses: [],
    statusesObjs: [],
    billingModes: [],
    billingModeObjs: [],
    startDate: '',
    endDate: ''
}
const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['sampleTypesObjs', 'testCodeObjs', 'statusesObjs', 'billingModeObjs', 'locationObjs', 'facilityObjs'];
const MODULE_NAME = "sampleList";
const SamplesListScreen = (props: SamplesListScreenProps) => {

        const [selectedLabIDForSendOut, setSelectedLabIDForSendOut] = useState<number | undefined>(undefined);
        const [selectedSampleList, setSelectedSampleList] = useState<ISample[]>([]);
        const [isSendOutDrawerOpened, setIsSendOutDrawerOpened] = useState<boolean>(false);
        const [isSendOutSessionInProgress, setIsSendOutSessionInProgress] = useState<boolean>(false);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);
        const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);

        const {
            // sampleTypesList,
            sampleTypeWithCollectionDevices,
            sampleStatusList,
            testListLite,
            billingModeList,
            facilityListLite,
            locationListLite
        } = useSelector((state: IRootReducerState) => state.staticData);

        const {
            response: labList = [],
            loading: isLabListLoading,
            loadingFailed: isLabListLoadingFailed,
            fetchData: fetchLabList
        } = useFetch<any[]>();

        const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));

        const [isCSVDownloading, setIsCSVDownloading] = useState(false);

        const [isBillingReportDownloading, setIsBillingReportDownloading] = useState(false);

        const dispatch = useDispatch();

        useEffect(() => {
            dispatch(setCurrentNavParams("Sample", "Sample"));
            dispatch(setSideMenuView('default'));
        }, [dispatch]);

        const handleSearch = useCallback((value: string) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: value
            }));
        }, []);

        useEffect(() => {
            if (queryParamData) {
                const data: any = {
                    search: queryParamData.search || '',
                    startDate: queryParamData.startDate || '',
                    endDate: queryParamData.endDate || '',
                };
                if (queryParamData?.statuses?.length) {
                    data['statuses'] = queryParamData.statuses.split(',') || [];
                }
                data['statusesObjs'] = sampleStatusList.filter((item: any) => data['statuses']?.includes(item?.code));
                if (queryParamData?.sampleStatuses?.length) {
                    data['statuses'] = queryParamData.sampleStatuses.split(',') || [];
                }
                data['statusesObjs'] = sampleStatusList.filter((item: any) => data['statuses']?.includes(item?.code));
                if (queryParamData?.facilityIds?.length) {
                    data['facilityIds'] = queryParamData.facilityIds.split(',') || [];
                }
                data['facilityObjs'] = facilityListLite.filter((item: any) => data['facilityIds']?.includes(item?.id?.toString()));

                if (queryParamData?.locationIds?.length) {
                    data['locationIds'] = queryParamData.locationIds.split(',') || [];
                }
                data['locationObjs'] = locationListLite.filter((item: any) => data['locationIds']?.includes(item?.id?.toString()));

                if (queryParamData?.sampleTypes?.length) {
                    data['sampleTypes'] = queryParamData.sampleTypes.split(',') || [];
                }
                // data['sampleTypesObjs'] = sampleTypesList.filter((item: any) => data['sampleTypes']?.includes(item?.id?.toString()));
                data['sampleTypesObjs'] = sampleTypeWithCollectionDevices?.filter((item: any) => data['sampleTypes']?.includes(item?.sampleType));


                if (queryParamData?.testIds?.length) {
                    data['testIds'] = queryParamData.testIds.split(',') || [];
                }
                data['testCodeObjs'] = testListLite.filter((item: any) => data['testIds']?.includes(item?.id?.toString()));

                if (queryParamData?.billingModes?.length) {
                    data['billingModes'] = queryParamData.billingModes.split(',') || [];
                }
                data['billingModeObjs'] = billingModeList.filter((item: any) => data['billingModes']?.includes(item?.id?.toString()));

                setFilterData((prevState: any) => ({
                    ...prevState, ...data
                }));
            }
        }, [queryParamData, sampleStatusList, sampleTypeWithCollectionDevices, testListLite, billingModeList, facilityListLite, locationListLite]);

        const applyFilters = useCallback((filterData: any) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                ...filterData
            }));
            setShowFiltersDrawer(false);
        }, []);

        useEffect(() => {
            CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
        }, [filterData]);

        const clearAllFilters = useCallback(() => {
            setFilterData(_.cloneDeep(FiltersInitialState));
        }, []);


        const showSendoutsDrawer = useCallback(() => {
            setIsSendOutDrawerOpened(true);
        }, []);

        const closeSendoutsDrawer = useCallback(() => {
            setIsSendOutDrawerOpened(false);
            setSelectedLabIDForSendOut(undefined);
        }, []);

        const handleMarkAsSendOuts = useCallback(() => {
            showSendoutsDrawer();
        }, [showSendoutsDrawer]);

        const getLabList = useCallback(() => {
            fetchLabList({
                url: APIConfig.FILTERED_LAB_LIST_LITE.URL,
                method: APIConfig.FILTERED_LAB_LIST_LITE.METHOD,
                payload: {"isActive": true, labRoles: ["sendLab", "sendReceiveLab"] as LabRoleType[],labType:'externalLab'}
            })
        }, [fetchLabList]);

        useEffect(() => {
            getLabList();
        }, [getLabList]);

        const handleSampleRemoveForSendOut = useCallback((sampleID: number) => {
            const updatedSampleList = selectedSampleList.filter(item => item.id !== sampleID);
            setSelectedSampleList(updatedSampleList);
        }, [setSelectedSampleList, selectedSampleList]);

        const submitSendOutSession = useCallback(() => {
            const payload = {
                sendoutLabId: selectedLabIDForSendOut,
                sampleIds: selectedSampleList.map(item => item.id),
                testIds: selectedSampleList.map(item => item.testDetails?.id)
            };
            setIsSendOutSessionInProgress(true);
            CommonService._lab.addNewSendOutSession(payload)
                .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast(response.message || 'Send out is successful', 'success');
                    setIsSendOutSessionInProgress(false);
                    setSelectedSampleList([]);
                    setSelectedLabIDForSendOut(undefined);
                    CommonService._communications.TableWrapperRefreshSubject.next({
                        moduleName: MODULE_NAME
                    });
                    closeSendoutsDrawer();
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error.message || 'Send out is failed', 'error');
                    setIsSendOutSessionInProgress(false);
                });
        }, [selectedSampleList, selectedLabIDForSendOut, closeSendoutsDrawer]);

        const downloadCSV = useCallback(() => {
            const payload = {...filterData};
            setIsCSVDownloading(true);
            CommonService._testOrder.downloadSampleListCsv(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsCSVDownloading(false);
                    if (response && response?.data && response?.data?.attachmentUrl) {
                        CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'testOrderList', 'csv');
                    }
                })
                .catch((error: any) => {
                    setIsCSVDownloading(false);
                });
        }, [filterData]);

        const downloadBillingReport = useCallback(() => {
            const payload = {...filterData};
            setIsBillingReportDownloading(true);
            CommonService._lab.downloadBillingReport(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsBillingReportDownloading(false);
                    if (response && response?.data && response?.data?.attachmentUrl) {
                        CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'Transaction Report', 'csv');
                    }
                })
                .catch((error: any) => {
                    setIsBillingReportDownloading(false);
                });
        }, [filterData])

        const sendOutsColumns: ITableColumn[] = [
            {id: 'barcode', label: 'Accession ID', isDefaultColumn: true},
            {id: 'sampleType', label: 'Sample Type', isDefaultColumn: true},
            {id: 'testDetails.code', label: 'Test Code', isDefaultColumn: true},
            {
                id: 'select',
                label: "",
                hideInColumnPreferences: true,
                isDefaultColumn: true,
                content: (item: ISample) => (
                    <>
                        <TooltipComponent tooltip={"Remove sample"} placement={"top"}>
                            <ButtonComponent variant={"icon"} handleClick={() => {
                                handleSampleRemoveForSendOut(item.id)
                            }}>
                                <RemoveCircle/>
                            </ButtonComponent>
                        </TooltipComponent>
                    </>
                )
            },
        ];

        return (
            <div className="samples-list-screen screen">
                <div className={"screen-content-wrapper"}>
                    <div className="page-data-wrapper">
                        <div className="page-options">
                            <div className="page-search">
                                <SearchComponent
                                    label={"Search"}
                                    id="search_input"
                                    placeholder={"Search by accession ID or re-assigned ID"}
                                    value={filterData.search}
                                    onChange={handleSearch}
                                />
                            </div>
                            <div className="page-extra-options">

                                {
                                    CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                    <ButtonComponent
                                        type="button"
                                        id="clear_all_filters"
                                        color={"secondary"}
                                        variant={"text"}
                                        fullWidth={false}
                                        handleClick={clearAllFilters}
                                    >
                                        Clear All
                                    </ButtonComponent>
                                }
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"primary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={() => setShowFiltersDrawer(true)}
                                    startIcon={<FilterAltIcon/>}>
                                    Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                                </ButtonComponent>
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"primary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={downloadBillingReport}
                                    isLoading={isBillingReportDownloading}
                                    disabled={isBillingReportDownloading}
                                    startIcon={<Download/>}
                                >
                                    Transaction Report
                                </ButtonComponent>
                                {
                                    commonService.checkAccess('TestOrderSample',
                                        'sampleCsvDownload', currentUser?.userAccessModules) &&
                                    <ButtonComponent
                                        type="button"
                                        id="csv_btn"
                                        color={"secondary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        handleClick={downloadCSV}
                                        isLoading={isCSVDownloading}
                                        disabled={isCSVDownloading}
                                        startIcon={<Download/>}
                                    >
                                        CSV
                                    </ButtonComponent>
                                }
                                {
                                    commonService.checkAccess('TestOrderSample',
                                        'sampleSendOut', currentUser?.userAccessModules) &&
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        handleClick={handleMarkAsSendOuts}
                                        disabled={selectedSampleList.length === 0}
                                    >
                                        Mark as Sendout {'( ' + selectedSampleList.length + ' )'}
                                    </ButtonComponent>
                                }

                            </div>
                        </div>
                        <>
                            <SamplesListTableComponent
                                filterData={filterData}
                                selectedSamples={selectedSampleList}
                                onSampleSelectUpdate={(sampleList) => setSelectedSampleList(sampleList)}/>
                        </>
                    </div>
                </div>
                <DrawerComponent open={isSendOutDrawerOpened}
                                 title={"Sendouts"}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 className={"drawer-wrapper"}
                                 onClose={closeSendoutsDrawer}
                >
                    <div className={"send-outs-drawer-container screen t-form-screen"}>
                        <div className={'t-form t-form-drawer'}>
                            <div className={'no-form'}>
                                <div className={'t-form-controls-wrapper mrg-top-20px'}>
                                    <SelectDropdownComponent
                                        name={"lab"}
                                        label={"Lab"}
                                        required={true}
                                        options={labList || []}
                                        isDataLoadingFailed={Boolean(isLabListLoadingFailed)}
                                        isDataLoading={isLabListLoading}
                                        valueKey={'id'}
                                        getOptionLabel={(option) => option?.name || ''}
                                        onUpdate={(value: any) => {
                                            setSelectedLabIDForSendOut(value);
                                        }}
                                    />
                                    <div className={"send-outs-count"}>
                                        Total Selected Samples : {selectedSampleList.length}
                                    </div>
                                    <div className={"drawer-body-wrapper"}>
                                        <TableComponent
                                            size={"small"}
                                            columns={sendOutsColumns}
                                            data={selectedSampleList}
                                            isStickyHeader={true}
                                        />
                                    </div>
                                </div>
                                <div className={"drawer-actions form-action-section"}>
                                    <ButtonComponent fullWidth={true}
                                                     color={"primary"}
                                                     handleClick={submitSendOutSession}
                                                     isLoading={isSendOutSessionInProgress}
                                                     disabled={(isSendOutSessionInProgress || selectedSampleList.length === 0 || !selectedLabIDForSendOut)}
                                    >
                                        Submit
                                    </ButtonComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </DrawerComponent>

                <DrawerComponent open={showFilterDrawer}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 className={"drawer-wrapper"}
                                 onClose={() => setShowFiltersDrawer(false)}
                >
                    <SamplesFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                             clearAllFilters={clearAllFilters}/>
                </DrawerComponent>
            </div>
        );
    }

;

export default SamplesListScreen;
